var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.93 4.755a.583.583 0 0 1 0 .825L2.096 7.412a3.176 3.176 0 0 0 4.49 4.491L8.42 10.07a.583.583 0 1 1 .825.825l-1.833 1.833a4.343 4.343 0 0 1-6.14-6.14l1.832-1.833a.583.583 0 0 1 .825 0M7.412 2.097 5.58 3.93a.583.583 0 0 1-.825-.825l1.832-1.833a4.343 4.343 0 0 1 6.141 6.14l-1.832 1.834a.583.583 0 0 1-.826-.825l1.833-1.833a3.176 3.176 0 0 0 0-4.491m-4.49 0a3.176 3.176 0 0 1 4.49 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.746 4.254a.583.583 0 0 1 0 .825L5.079 9.746a.583.583 0 1 1-.825-.825l4.667-4.667a.583.583 0 0 1 .825 0",
    clipRule: "evenodd"
  })));
};
export default SvgLink;